import { Star } from 'lucide-react';

const CTASection = ({ title, subtitle, buttonText, link, backgroundImage }) => {
  return (
    <section
      id="financing" 
      className="relative bg-cover bg-center bg-no-repeat text-white text-center py-[120px]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black/50 z-0" />
      <div className="relative z-10 max-w-[900px] mx-auto px-6">
        {/* Optional stars */}
        <div className="flex justify-center mb-4">
          {[...Array(5)].map((_, idx) => (
            <Star key={idx} className="w-6 h-6 mr-2 fill-primary text-transparent" />
          ))}
        </div>

        <p className="uppercase tracking-[6px] text-sm text-white font-light mb-2">
          {subtitle}
        </p>

        <h2 className="text-4xl md:text-5xl font-gilda font-light leading-tight mb-6">
          {title}
        </h2>

        <div className="text-center mt-12">
          <a
            href={link || "/contact"}
            className="inline-block text-lg uppercase py-3 px-8 bg-primary text-white font-base hover:bg-black transition-all duration-500 ease-in-out"
          >
            {buttonText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
